import type { ComponentProps } from "react"
import { CheckboxField } from "@motley/design"
import FormControl from "./FormControl"

type Props = Omit<ComponentProps<typeof CheckboxField>, "name"> & {
  name: string
}

export default function FormCheckbox({
  name,
  helperText,
  onCheckedChange,
  ...inputProps
}: Props) {
  return (
    <FormControl name={name}>
      {({ field: { value, onChange, ...field }, isError, error }) => (
        <CheckboxField
          checked={!!value}
          helperText={helperText}
          error={error}
          aria-invalid={isError}
          onCheckedChange={(checked, event) => {
            onChange(checked)
            onCheckedChange?.(checked, event)
          }}
          {...field}
          {...inputProps}
        />
      )}
    </FormControl>
  )
}
